exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".renewalDetail[data-v-59d88a3e]{padding-bottom:1.866667rem}.pay-footer[data-v-59d88a3e]{display:flex;justify-content:flex-end;align-items:center;position:fixed;bottom:0;left:0;width:100%;background:#fff}.pay-footer>div[data-v-59d88a3e]{margin-right:.266667rem}.pay-footer>div span[data-v-59d88a3e]{color:#ff6c6c}.pay-footer button[data-v-59d88a3e]{padding:0 .8rem;background:#00d8a0!important;border:.026667rem solid #00d8a0!important}.packageStyle[data-v-59d88a3e]{margin-top:.266667rem}textarea[data-v-59d88a3e]{border:0}", ""]);

// exports
